import { generateGuid } from 'guid';

export default angular.module('guid', []).factory('guid', [
    () => {
        return {
            generate: generateGuid,
        };
    },
]);
